import { render, staticRenderFns } from "./verhuis-details.vue?vue&type=template&id=280700cc"
import script from "./verhuis-details.vue?vue&type=script&lang=js"
export * from "./verhuis-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports